// src/components/chat/HeroTraceOverlay.tsx
//
// The constant-speed border-trace overlay for empty-chat hero composers:
// a small dot of light travels one lap along the traced field's border.
// See HeroEntrance.module.css for the mechanism (SVG dash, not conic
// rotation) and the shared `heroIntro` rise class.
//
// Usage: give the element that visually IS the field (input root, Paper)
// the `heroEntranceClasses.heroTraceHost` class (position: relative +
// trace colour) and render this overlay as a child, only in the hero
// state. `rx` must be the field's border-radius in px + 1 (the svg sits
// 1px outside the field).
import classes from "./HeroEntrance.module.css";

export const heroEntranceClasses = classes;

export function HeroTraceOverlay({ rx }: { rx: number }) {
  return (
    <svg className={classes.heroTraceSvg} aria-hidden="true">
      <rect x="0" y="0" width="100%" height="100%" rx={rx} pathLength={100} />
    </svg>
  );
}
